import React, { useMemo } from "react"
import types from "prop-types"
import { isEmpty, isEqual } from "lodash-es"
import { useDispatch, useSelector } from "react-redux"
import {
  selectedCategorySlug,
  selectedTaskFormSlug,
  selectTaskForm,
  taskForms,
} from "reduxSlices/taskReportBuilderSlice"
import { Select } from "shared/selects"

const taskFormToOption = (taskForm) => (
  {
    label: taskForm.title,
    sort: taskForm.title.toLowerCase(),
    value: taskForm.slug,
  }
)

const TaskFormSelector = ({ className = "" }) => {
  const dispatch = useDispatch()

  const storedTaskForms = useSelector(taskForms, isEqual)
  const categorySlug = useSelector(selectedCategorySlug)
  const taskFormSlug = useSelector(selectedTaskFormSlug)

  const taskFormOptions = useMemo(() => (
    storedTaskForms.map(taskFormToOption)
  ), [storedTaskForms])

  const handleTaskFormChange = (slug) => {
    dispatch(selectTaskForm({ taskFormSlug: slug }))
  }

  if (!categorySlug) return null

  if (isEmpty(taskFormOptions)) {
    return (
      <p className="text-xs text-dark">
        There are no task forms in the selected solution.
      </p>
    )
  }

  return (
    <Select
      className={className}
      onChange={handleTaskFormChange}
      options={taskFormOptions}
      sortBy="sort"
      value={taskFormSlug}
      label="select task form"
    />
  )
}

TaskFormSelector.propTypes = {
  className: types.string,
}

export default TaskFormSelector
